export default "__VITE_ASSET__UeVES10K__"